/* eslint-disable sort-keys */
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import typography from '@amblique/king-living/app/theme/foundations/typography';

const helpers = createMultiStyleConfigHelpers(['root', 'sectionHeading', 'sectionTitle', 'grid', 'gridItem']);

/**
 * CategoryCardGrid contentful model styles.
 * Theme key: 'contentful/category-card-grid'
 *
 * Layout: 2 columns on mobile, 3 columns on desktop.
 * All visual decisions live here — the component uses only className and theme parts.
 */
export const categoryCardGridStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      gap: {base: 6, lg: 11},
      maxWidth: 'container.xxl',
      mx: 'auto',
      px: {base: 5, md: 20},
      width: '100%',
    },
    sectionHeading: {
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      display: 'flex',
      gap: 10,
      position: 'relative',
      width: 'full',
    },
    sectionTitle: {
      ...typography.textStyles.sectionTitle,
      color: 'brandColors.greyscale90',
      flex: '1 0 0',
      mb: 0,
      position: 'relative',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: {base: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)'},
      columnGap: {base: '3px', lg: '4px'},
      rowGap: {base: '16px', lg: '80px'},
      width: '100%',
    },
    gridItem: {
      width: '100%',
      minWidth: 0,
    },
  },
});
